/* eslint-disable max-lines */
export interface PreEmploymentFormData {
  legalFirstName: string;
  legalLastName: string;
  maidenName: string;
  address: string;
  county: string;
  city: string;
  state: string;
  zipCode: string;
  otherStatesLived: string;
  phoneNumber: string;
  email: string;
  dob: string;
  ssn: string;
  shirtSize: string;
  allergies: string;

  emergencyName: string;
  emergencyRelationship: string;
  emergencyAddress: string;
  emergencyPhoneH: string;
  emergencyPhoneC: string;
  emergencyPhoneOther: string;

  licenseHeld: boolean | undefined;
  disciplinaryAction: boolean | undefined;
  abuseNeglect: boolean | undefined;
  abuseNeglectExplanation: string;
  atLeast18: boolean | undefined;
  convictedOfCrime: boolean | undefined;
  crimeExplanation: string;
  objectToFingerprinting: boolean | undefined;
  legallyAbleToWork: boolean | undefined;
  thirdPartyAgreement: boolean | undefined;
  physicalLimitations: string;
  physicalLimitationsExplanation: string;

  highestGradeCompleted: string;
  gedCollegeCompleted: string;
  highSchoolNameLocation: string;
  highSchoolDatesAttended: string;
  highSchoolCourseOfStudy: string;
  highSchoolDegreeDiploma: string;
  highSchoolNameLocation2: string;
  highSchoolDatesAttended2: string;
  highSchoolCourseOfStudy2: string;
  highSchoolDegreeDiploma2: string;
  collegeUniversityNameLocation: string;
  collegeUniversityDatesAttended: string;
  collegeUniversityCourseOfStudy: string;
  collegeUniversityDegreeDiploma: string;
  collegeUniversityNameLocation2: string;
  collegeUniversityDatesAttended2: string;
  collegeUniversityCourseOfStudy2: string;
  collegeUniversityDegreeDiploma2: string;
  graduateProfessionalNameLocation: string;
  graduateProfessionalDatesAttended: string;
  graduateProfessionalCourseOfStudy: string;
  graduateProfessionalDegreeDiploma: string;
  graduateProfessionalNameLocation2: string;
  graduateProfessionalDatesAttended2: string;
  graduateProfessionalCourseOfStudy2: string;
  graduateProfessionalDegreeDiploma2: string;
  stateCredentialNameLocation: string;
  stateCredentialDatesAttended: string;
  stateCredentialCourseOfStudy: string;
  stateCredentialDegreeDiploma: string;
  childcareTraining: string;

  references: string;

  signature: string;
  date: string;
}

export interface EmploymentHistoryEntry {
  placeOfEmployment: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  datesOfEmploymentFrom: string;
  datesOfEmploymentUntil: string;
  positionHeld: string;
  supervisor: string;
  reasonForLeaving: string;
  jobDescription: string;
  currentlyEmployed: boolean;
}

export interface EmploymentHistoryData {
  applicantName: string;
  positionAppliedFor: string;
  history: EmploymentHistoryEntry[];
}

export const emptyHistoryEntry = (): EmploymentHistoryEntry => ({
  placeOfEmployment: '',
  phone: '',
  address: '',
  city: '',
  state: '',
  datesOfEmploymentFrom: '',
  datesOfEmploymentUntil: '',
  positionHeld: '',
  supervisor: '',
  reasonForLeaving: '',
  jobDescription: '',
  currentlyEmployed: false,
});

export const buildEmptyPreEmployment = (): PreEmploymentFormData => ({
  legalFirstName: '',
  legalLastName: '',
  maidenName: '',
  address: '',
  county: '',
  city: '',
  state: '',
  zipCode: '',
  otherStatesLived: '',
  phoneNumber: '',
  email: '',
  dob: '',
  ssn: '',
  shirtSize: '',
  allergies: '',
  emergencyName: '',
  emergencyRelationship: '',
  emergencyAddress: '',
  emergencyPhoneH: '',
  emergencyPhoneC: '',
  emergencyPhoneOther: '',
  licenseHeld: undefined,
  disciplinaryAction: undefined,
  abuseNeglect: undefined,
  abuseNeglectExplanation: '',
  atLeast18: undefined,
  convictedOfCrime: undefined,
  crimeExplanation: '',
  objectToFingerprinting: undefined,
  legallyAbleToWork: undefined,
  thirdPartyAgreement: undefined,
  physicalLimitations: '',
  physicalLimitationsExplanation: '',
  highestGradeCompleted: '',
  gedCollegeCompleted: '',
  highSchoolNameLocation: '',
  highSchoolDatesAttended: '',
  highSchoolCourseOfStudy: '',
  highSchoolDegreeDiploma: '',
  highSchoolNameLocation2: '',
  highSchoolDatesAttended2: '',
  highSchoolCourseOfStudy2: '',
  highSchoolDegreeDiploma2: '',
  collegeUniversityNameLocation: '',
  collegeUniversityDatesAttended: '',
  collegeUniversityCourseOfStudy: '',
  collegeUniversityDegreeDiploma: '',
  collegeUniversityNameLocation2: '',
  collegeUniversityDatesAttended2: '',
  collegeUniversityCourseOfStudy2: '',
  collegeUniversityDegreeDiploma2: '',
  graduateProfessionalNameLocation: '',
  graduateProfessionalDatesAttended: '',
  graduateProfessionalCourseOfStudy: '',
  graduateProfessionalDegreeDiploma: '',
  graduateProfessionalNameLocation2: '',
  graduateProfessionalDatesAttended2: '',
  graduateProfessionalCourseOfStudy2: '',
  graduateProfessionalDegreeDiploma2: '',
  stateCredentialNameLocation: '',
  stateCredentialDatesAttended: '',
  stateCredentialCourseOfStudy: '',
  stateCredentialDegreeDiploma: '',
  childcareTraining: '',
  references: '',
  signature: '',
  date: '',
});

export const buildEmptyHistory = (): EmploymentHistoryData => ({
  applicantName: '',
  positionAppliedFor: '',
  history: [emptyHistoryEntry(), emptyHistoryEntry(), emptyHistoryEntry()],
});

export const PRE_EMPLOYMENT_STORAGE_KEY = (token: string) => `newhire-v2-pre-employment:${token}`;
export const PRE_EMPLOYMENT_HISTORY_STORAGE_KEY = (token: string) => `newhire-v2-pre-employment-history:${token}`;
